import React from 'react';
import { Link } from 'react-router-dom';

const ProjectSectionS2 = ({ projects, projectsIsloading, projectsError }) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <div className="wpo-project-area-s2 section-padding">
            <div className="container">
                <div className="row  align-items-center">
                    <div className="wpo-project-wrap">
                        <div className="sortable-gallery">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="project-grids gallery-container clearfix">
                                        {projectsIsloading ? 'Loading...' : projectsError ? 'Error' : projects.map((project, pot) => (
                                            <div className="grid" key={pot}>
                                                <div className="wpo-project-item">
                                                    <div className="wpo-project-img">
                                                        <img src={`${process.env.REACT_APP_API_URL}/api/images/${project?.data?.thumbnail}`} alt="" />
                                                        <div className="left-border"></div>
                                                        <div className="right-border"></div>
                                                    </div>
                                                    <div className="wpo-project-text">
                                                        <h2><Link onClick={ClickHandler} to={`/project-single/${project?.slug}`}>{project?.data?.title}</Link></h2>
                                                        <span>{project?.data?.description.slice(0, 60)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectSectionS2;

